// To mock API Responses for testing components
import { mockAccountList } from "mocks/responses/itsmResponses"

export const projectsResponse = {
  user: "user@deloitte.com",
  primaryProjectID: "p000314",
  projects: ["p000314", "p000256", "p000303", "p000121"]
}

export const projectNamesResponse = [
  {
    u_project_name: "CMP Client Portal",
    u_number: "p000314",
    u_project_pinned: false
  },
  {
    u_project_name: "Adidas - Tax Compliance Solution",
    u_number: "p000256",
    u_project_pinned: false
  },
  {
    u_project_name: "Metro Bank",
    u_number: "p000303",
    u_project_pinned: false
  },
  {
    u_project_name: "HSBC Estates",
    u_number: "p000121",
    u_project_pinned: false
  }
]

export const projectNamesResponse2Pinned = [
  {
    u_project_name: "CMP Client Portal",
    u_number: "p000314",
    u_project_pinned: true
  },
  {
    u_project_name: "Adidas - Tax Compliance Solution",
    u_number: "p000256",
    u_project_pinned: true
  },
  {
    u_project_name: "Metro Bank",
    u_number: "p000303",
    u_project_pinned: false
  },
  {
    u_project_name: "HSBC Estates",
    u_number: "p000121",
    u_project_pinned: false
  }
]
export const projectNamesResponse1Pinned = [
  {
    u_project_name: "CMP Client Portal",
    u_number: "p000314",
    u_project_pinned: false
  },
  {
    u_project_name: "Adidas - Tax Compliance Solution",
    u_number: "p000256",
    u_project_pinned: true
  },
  {
    u_project_name: "Metro Bank",
    u_number: "p000303",
    u_project_pinned: false
  },
  {
    u_project_name: "HSBC Estates",
    u_number: "p000121",
    u_project_pinned: false
  }
]

export const singleProject = [
  {
    u_project_name: "CMP Client Portal",
    u_number: "p000314",
    u_project_pinned: false
  }
]

export const pinnedProjects = {
  pinned_projects: ["p000314", "p000121"]
}

export const portalAdminPolicy = {
  user: {
    projects: projectsResponse.projects,
    projectNames: projectNamesResponse,
    name: "Test User",
    email: "test@example.com",
    isAuthenticated: true,
    bearerToken: "12345",
    isLoggingIn: null,
    isLoggingOut: null,
    tokenExpires: new Date().getTime(),
    accounts: mockAccountList,
    role: "Portal-Admin"
  },
  settings: {
    currentProject: projectsResponse.projects[0]
  }
}
